import { GlModal, GlButton } from '@gitlab/ui';
import { __ } from '~/locale';
export default {
    name: 'RebaseConfirmationDialog',
    i18n: {
        primary: __('Rebase'),
        cancel: __('Cancel'),
        info: __('This will rebase all commits from the source branch onto the target branch.'),
        title: __('Rebase source branch?')
    },
    components: {
        GlModal,
        GlButton
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'cancel',
        'rebase-confirmed'
    ],
    methods: {
        hide () {
            this.$refs.modal.hide();
        },
        cancel () {
            this.hide();
            this.$emit('cancel');
        },
        focusCancelButton () {
            this.$refs.cancelButton.$el.focus();
        },
        confirmRebase () {
            this.$emit('rebase-confirmed');
            this.hide();
        }
    }
};
